export function getMobileOS() {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  
    // iOS detection
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      return 'IOS';
    }
  
    // Android detection
    if (/android/i.test(userAgent)) {
      return 'ANDROID';
    }
  
    // Neither iOS nor Android
    return null;
}